import React from 'react';
import styled from 'styled-components';

const FlexItem = styled.div`
  flex: 1 0 auto;
  padding: 13px 0 12px;
`;

export default FlexItem;
